const LNS_PREFIX = 'LNS error: ';
const SERVER_ERROR_MESSAGE = 'Something went wrong. Please try again later.';
const NETWORK_ERROR_MESSAGE =
  'Networking issue. Check your connection and try again.';
const MAINTENANCE_MESSAGE =
  'The service is currently under maintenance. Please try again in a few minutes.';

export const getLottoErrorMessage = (error) => {
  if (!error) return SERVER_ERROR_MESSAGE;

  if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
    return NETWORK_ERROR_MESSAGE;
  }

  const status = error.response?.status;
  if ([500, 502, 503, 504].includes(status)) {
    return MAINTENANCE_MESSAGE;
  }

  const msg = error.response?.data?.error?.msg ?? '';
  const clean = msg.startsWith(LNS_PREFIX) ? msg.slice(LNS_PREFIX.length) : msg;
  const trimmed = clean.trim();
  return trimmed
    ? trimmed[0].toUpperCase() + trimmed.slice(1)
    : SERVER_ERROR_MESSAGE;
};
